module.exports = __webpack_public_path__ + "static/media/add-contact.d44e5cae.png";